<template>
  <header id="header1">
    <div class="cnt1 clearfix"></div>
    <div class="cnt2 clearfix">
      <GlobalNavikanriComponent :previewData="gloNaviPreviewDataList" />
    </div>
  </header>
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div class="form-group" style="text-align: center">
    <button
      type="button"
      name="btnBack"
      class="btn btn-back btn-primary"
      @click="goback"
    >
      戻る
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, PropType } from "vue";
import { commonHandleAxiosError } from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import { useProcessingStore } from "../../store/useProcessingStore";
import GlobalNavikanriComponent from "../layout/GlobalNaviKanriComponent.vue";

interface GloNaviPreviewDataList {
  categoryId: string;
  parentId: string;
  itemName: string;
  itemUrl: string;
}

export default defineComponent({
  name: "GlobalNaviPreviewComponent",
  components: {
    // ここにプレビュー用のグローバルナビコンポーネントを記載
    GlobalNavikanriComponent,
  },
  props: {
    glovalNaviKanriId: {
      type: String as PropType<string>,
      required: true,
    },
    detailKbn: {
      type: String as PropType<string>,
      required: true,
    },
  },
  setup(props) {
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const agCode = ref(""); // ローカルストレージ．AGコード
    const userId = ref(""); // ローカルストレージ．ユーザーID
    const glonaviKanriId = ref("");
    const detailKbn = ref("");
    const gloNaviPreviewDataList = ref<GloNaviPreviewDataList[]>([]);

    // 初期処理
    onMounted(async () => {
      glonaviKanriId.value = props.glovalNaviKanriId;
      detailKbn.value = props.detailKbn;

      console.log(props.detailKbn);

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
        }
        // 初期処理時はTrue
        isInitError.value = true;

        // プレビューデータ取得
        const response = await apiAuthClient.post(
          "/api/GlovalNaviManegment/getPreviewData",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: agCode.value,
            userId: userId.value,
            GlonaviKanriId: glonaviKanriId.value,
            detailKbn: detailKbn.value,
          }
        );

        gloNaviPreviewDataList.value = response.data.gloNaviPreviewDataList;

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    });

    /** 戻る処理 */
    const goback = () => {
      // もとの画面に戻る処理
      window.close();
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, true);
    };

    return {
      isInitError,
      isDataFetched,
      errorMessage,
      isKaunetAdmin,
      gloNaviPreviewDataList,
      goback,
    };
  },
});
</script>
<style>
.btn-back {
  margin-top: 10%;
  border-radius: 1rem;
  width: 140px;
}
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
</style>
